import * as types from './account-project.types';
import * as constants from './account-project.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeAccountProject = generateStoreResourceAction<types.IAccountProject>(constants.STORE_ACCOUNT_PROJECT);
export const clearAccountProject = generateClearResourceAction(constants.CLEAR_ACCOUNT_PROJECT);
